import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useClienteAtual } from '../../empresasCliente-list/core/useClienteAtual'
import { cargoColumns } from './columns/_columns'
import { CargoAsoList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const CargoClienteTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const cliente = useClienteAtual()
  const { t } = useT()

  const columns = useMemo(() => cargoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum cargo encontrado para “${filters.nome.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={
        cliente?.nome ? `Nenhum cargo cadastrado em ${cliente.nome}` : 'Nenhum cargo cadastrado'
      }
      description='Use “Adicionar” para cadastrar o primeiro cargo.'
    />
  )

  return (
    <CustomTable<CargoAsoList>
      id='kt_table_cargos_cliente'
      ariaLabel='Cargos'
      itemLabel={{ singular: 'cargo', plural: 'cargos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
